
export const FETCH_BALANCE = 'FETCH_BALANCE';
export const FETCH_BALANCE_SUCCESS = 'FETCH_BALANCE_SUCCESS';



// WEBPACK FOOTER //
// ./src/data/balance/types.js